import moment from 'moment';
import {formatDate} from 'common/formatters/date-formatter';
import {DateTimeFormat, TimeResolutionEnum} from 'common/proxies/enum-proxy';
import {isValid} from 'validators/number-validator';

export const getNumTicks = (groups) => {
  if (groups && groups.length) {
    const group = groups[0];
    if (group && group.series && group.series.length) {
      const series = group.series[0];
      if (series && series.data) {
        return series.data.length;
      }
    }
  }
  return 0;
};

export const getTicks = (scale, numTicks) => {
  if (
    typeof scale === 'function' &&
    scale.hasOwnProperty('ticks') &&
    isValid(numTicks)
  ) {
    return scale.ticks(numTicks);
  }
  return [];
};

export const getTimeTickFormat = (resolution, duration) => {
  if (!resolution) {
    return '';
  }

  switch (resolution.id) {
    case TimeResolutionEnum.MONTH.id:
      return DateTimeFormat.MONTH;

    case TimeResolutionEnum.DAY.id:
      if (duration && duration <= moment.duration(1, 'week')) {
        return DateTimeFormat.DAY_OF_WEEK;
      }
      return DateTimeFormat.DAY;

    case TimeResolutionEnum.WEEK.id:
      return DateTimeFormat.TEXTUAL_MONTH_DAY;

    case TimeResolutionEnum.HOUR.id:
    case TimeResolutionEnum.QUARTER_HOUR.id:
    case TimeResolutionEnum.LIVE.id:
      return DateTimeFormat.TIME;

    default:
      return DateTimeFormat.YEAR;
  }
};

export const getTimeTicks = (data, frequency, format) => {
  return data.map((datum, index) => {
    if (index % frequency === 0) {
      const tickFormat = datum.tickFormat || format;
      if (tickFormat) {
        return formatDate(datum.date, tickFormat);
      }
      return '';
    }
    return '';
  });
};
